import { ReactNode, useMemo } from 'react';

export interface ControlTabProps {
  active: boolean;
  onClick: () => void;
  type: 'text' | 'icon';
  children: ReactNode;
  position: 'first' | 'middle' | 'last';
  disabled?: boolean;
}

const positionMap = {
  first: 'rounded-l-lg border',
  middle: 'border-t border',
  last: 'rounded-r-lg border',
};

export const ControlTab = ({
  children,
  active,
  onClick,
  type,
  position,
  disabled,
}: ControlTabProps) => {
  const styles = useMemo(() => {
    return [
      'uppercase transition-colors',
      positionMap[position],
      disabled ? 'opacity-75 cursor-not-allowed' : '',
      active
        ? 'bg-pink-300/20 text-pink-500 border-pink-500'
        : 'bg-transparent text-gray-500 hover:border-gray-300',
      type === 'icon'
        ? 'h-10 w-10 flex-none flex items-center justify-center'
        : 'p-4 flex-1',
    ].join(' ');
  }, [active, type, position, disabled]);

  return (
    <button
      type="button"
      onClick={onClick}
      className={styles}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default ControlTab;
